import { createContext } from 'react'

// Potentially share admin options/data through the app in the future
export const AdminContext = createContext(null as any)
AdminContext.displayName = 'AdminContext'
